import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { CompaniesDataGrid } from "src/components/views/erp/common/companies/CompaniesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/common/companies")({
	staticData: { title: i18n.t("companies"), legacyViewKey: "companiesDataTableView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <CompaniesDataGrid />;
}
